// reduce the height of hero to always be above the fold.
if (document.querySelector('.pd-p-calloutbannerlayout')) {
	const targetElements = document.querySelectorAll('.pd-c-herofullwidth.pd-c-banner-common .component-figure');
	targetElements.forEach((element) => {
		element.classList.add('height-sm');
	});
}

function initDismissable() {
	const $container = $('.pd-l-1rowdismissable');
	const $closeButton = $container.find('.btn-dismiss');
	$closeButton.on('click', (e) => {
		e.stopPropagation();
		// Remove 'height-sm' class when the dismiss button is clicked
		const targetElements = document.querySelectorAll('.pd-c-herofullwidth.pd-c-banner-common .component-figure');
		targetElements.forEach((element) => {
			element.classList.remove('height-sm');
		});
		const cookieId = $container.data('cookieid');
		const durationInDays = $container.data('hideduration');
		const date = new Date();
		date.setTime(date.getTime() + (durationInDays * 24 * 60 * 60 * 1000));
		const expires = date.toUTCString();
		document.cookie = `${cookieId}=hideElements; expires=${expires}; path=/`;
		$container.slideUp(500);
	});
}

initDismissable();
